import { useEffect } from 'react'

export function useScrollFadeIn() {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('v')
            obs.unobserve(e.target)
          }
        })
      },
      { threshold: 0.07 },
    )

    document.querySelectorAll('.fu').forEach((el) => obs.observe(el))

    // Staggered hero animations
    document.querySelectorAll('.hero .fu').forEach((el, i) => {
      setTimeout(() => el.classList.add('v'), 200 + i * 120)
    })

    return () => {
      obs.disconnect()
    }
  }, [])
}
